import Struct, { NumberFieldDefinition, NumberFieldType, placeholder, } from "@yume-chan/struct";
import { ScrcpyControlMessageType } from "./type.js";
// https://developer.android.com/reference/android/view/MotionEvent#constants_1
export var AndroidMotionEventAction;
(function (AndroidMotionEventAction) {
    AndroidMotionEventAction[AndroidMotionEventAction["Down"] = 0] = "Down";
    AndroidMotionEventAction[AndroidMotionEventAction["Up"] = 1] = "Up";
    AndroidMotionEventAction[AndroidMotionEventAction["Move"] = 2] = "Move";
    AndroidMotionEventAction[AndroidMotionEventAction["Cancel"] = 3] = "Cancel";
    AndroidMotionEventAction[AndroidMotionEventAction["Outside"] = 4] = "Outside";
    AndroidMotionEventAction[AndroidMotionEventAction["PointerDown"] = 5] = "PointerDown";
    AndroidMotionEventAction[AndroidMotionEventAction["PointerUp"] = 6] = "PointerUp";
    AndroidMotionEventAction[AndroidMotionEventAction["HoverMove"] = 7] = "HoverMove";
    AndroidMotionEventAction[AndroidMotionEventAction["Scroll"] = 8] = "Scroll";
    AndroidMotionEventAction[AndroidMotionEventAction["HoverEnter"] = 9] = "HoverEnter";
    AndroidMotionEventAction[AndroidMotionEventAction["HoverExit"] = 10] = "HoverExit";
    AndroidMotionEventAction[AndroidMotionEventAction["ButtonPress"] = 11] = "ButtonPress";
    AndroidMotionEventAction[AndroidMotionEventAction["ButtonRelease"] = 12] = "ButtonRelease";
})(AndroidMotionEventAction = AndroidMotionEventAction || (AndroidMotionEventAction = {}));
// eslint-disable-next-line @typescript-eslint/no-namespace
export var ScrcpyPointerId;
(function (ScrcpyPointerId) {
    ScrcpyPointerId.Mouse = BigInt(-1);
    ScrcpyPointerId.Finger = BigInt(-2);
    ScrcpyPointerId.VirtualMouse = BigInt(-3);
    ScrcpyPointerId.VirtualFinger = BigInt(-4);
})(ScrcpyPointerId = ScrcpyPointerId || (ScrcpyPointerId = {}));
export function clamp(value, min, max) {
    if (value < min) {
        return min;
    }
    if (value > max) {
        return max;
    }
    return value;
}
export const ScrcpyFloatToUint16NumberType = {
    size: 2,
    signed: false,
    deserialize(array, littleEndian) {
        const value = NumberFieldType.Uint16.deserialize(array, littleEndian);
        // https://github.com/Genymobile/scrcpy/blob/1f138aef41de651668043b32c4effc2d4adbfc44/server/src/main/java/com/genymobile/scrcpy/Binary.java#L22
        return value === 0xffff ? 1 : value / 0x10000;
    },
    serialize(dataView, offset, value, littleEndian) {
        // https://github.com/Genymobile/scrcpy/blob/1f138aef41de651668043b32c4effc2d4adbfc44/app/src/util/binary.h#L51
        value = clamp(value, -1, 1);
        value = value === 1 ? 0xffff : value * 0x10000;
        NumberFieldType.Uint16.serialize(dataView, offset, value, littleEndian);
    },
};
const ScrcpyFloatToUint16FieldDefinition = new NumberFieldDefinition(ScrcpyFloatToUint16NumberType);
export const ScrcpyInjectTouchControlMessage = new Struct()
    .uint8("type", ScrcpyControlMessageType.InjectTouch)
    .uint8("action", placeholder())
    .uint64("pointerId")
    .uint32("pointerX")
    .uint32("pointerY")
    .uint16("screenWidth")
    .uint16("screenHeight")
    .field("pressure", ScrcpyFloatToUint16FieldDefinition)
    .uint32("buttons");
//# sourceMappingURL=inject-touch.js.map